import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import EventoEs from './views/EventoEs.vue';
import EventoPt from './views/EventoPt.vue';
import InfoEs from './views/InfoEs.vue';
import InfoPt from './views/InfoPt.vue';
import store from "@/store.js";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: '/incoterms'
    },
    {
      path: "/incoterms",
      name: "incoterms",
      component: Home
    },
    {
      path: "/ondemand/por/evento",
      name: "eventopt",
      component: EventoPt
    },
    {
      path: "/ondemand/es/evento",
      name: "eventoes",
      component: EventoEs
    },
    {
      path: "/es/info",
      name: "infoes",
      component: InfoEs
    },
    {
      path: "/pt/info",
      name: "infopt",
      component: InfoPt,
    },
  ]
});

router.beforeEach((to, from, next) => {
  if (to.query.auth == 1) {
    next();
  } else {
    if (to.matched.some(record => record.meta.authRequired)) {
      if (!store.state.isAuthenticated) {
        next({ path: '/incoterms' });
      } else {
        next();
      }
    } else {
      next();
    }
  }

});


export default router;